/**
 * NavUser.js
 * Created by calhosh on 3/14/2022.
 */

import React, {Fragment, useCallback} from 'react';
import {
	MotifDropdown,
	MotifDropdownItem,
	MotifIconButton
} from '@ey-xd/motif-react';
import {labels} from '../../utils/utils';
import Ellipses from '../EllipsesPresets/EllipsesPresets';
import Env from '../../utils/env';
import DelegateAccessModal from '../../../features/users/components/DelegateAccess/DelegateAccessModal';
import {useHistory} from 'react-router-dom';
import {toggleUnsavedModal} from '../UnsavedChangesModal/UnsavedChangesModal';
import {modalSource} from '../../utils/uiconstants';
import { useSelector } from 'react-redux';

const NavUser = ({
	validEconomicsUser,
	validAdminUser,
	user,
	admin,
	isOpen,
	setIsOpen,
	isModalVisible,
	setModalVisibility,
	hasChanges,
	partitionKey
}) => {
	const history = useHistory();
    const paansData = useSelector((store) => store.paansuserdata)

	const setUserInitials = (user) => {
		if (user && user.id) {
			return (
				<span className="user-initials">
					{user && user.firstName?.slice(0, 1).toUpperCase()}
					{user && user.lastName?.slice(0, 1).toUpperCase()}
				</span>
			);
		}
	};

	const showOptions = useCallback(() => {
		if (hasChanges) {
			toggleUnsavedModal(modalSource.navUser, {partitionKey});
		} else {
			setIsOpen(!isOpen);
		}
	}, [isOpen, hasChanges]);

	const hideOption = useCallback(() => {
		setIsOpen(false);
	}, []);

	const openSettings = useCallback(() => {
		setIsOpen(!isOpen);
		history.push({
			pathname: `/settings`
		});
	}, [isOpen]);

	const openDelegates = useCallback(() => {
		setIsOpen(!isOpen);
		setModalVisibility(true);
	}, [isOpen]);

	const logout = useCallback(() => {
		setIsOpen(!isOpen);
		window.location.href = Env.getLogoutUrl();
	}, [isOpen, Env]);

    const onClickPrivacyNotice = useCallback(() => {
		setIsOpen(!isOpen);
        window.open(paansData.privacyNoticeDocumentUrl);
	}, [isOpen]);

	return (
		<section className="nav-bar_right-wrapper">
			<section className="nav-bar__user-profile">
				{(validEconomicsUser || validAdminUser) && (
					<Fragment>
						<MotifDropdown
							open={isOpen}
							placement="bottom-right"
							id="userSettings"
							aria-labelledby="dropdown-trigger"
							handleClickOutside={hideOption}
							trigger={
								<MotifIconButton
									type="button"
									onClick={showOptions}
									aria-controls="open-delegate-access"
									id="dropdown-trigger"
									aria-expanded={isOpen}
									aria-label="open-delegate-access"
									className="delegate-btn"
									title={labels.userOptions}
								>
									{setUserInitials(validEconomicsUser ? user : admin)}
								</MotifIconButton>
							}
						>
							<MotifDropdownItem onClick={openSettings}>
								<Ellipses.Single>
									{labels.userOptionsDropdown.userSettings}
								</Ellipses.Single>
							</MotifDropdownItem>
							{!validAdminUser ? (
								<MotifDropdownItem onClick={openDelegates}>
									<Ellipses.Single>
										{labels.userOptionsDropdown.delegateAccess}
									</Ellipses.Single>
								</MotifDropdownItem>
							) : (
								[]
							)}
							{paansData && paansData?.privacyNoticeDocumentUrl ? (
								<MotifDropdownItem onClick={onClickPrivacyNotice}>
									<Ellipses.Single>
										{labels.userOptionsDropdown.privacyNotice}
									</Ellipses.Single>
								</MotifDropdownItem>
							) : (
								[]
							)}
							<MotifDropdownItem onClick={logout}>
								<Ellipses.Single>
									{labels.userOptionsDropdown.signOut}
								</Ellipses.Single>
							</MotifDropdownItem>
						</MotifDropdown>
						<DelegateAccessModal
							showModal={isModalVisible}
							setModalVisibility={setModalVisibility}
						/>
					</Fragment>
				)}
			</section>
		</section>
	);
};

export default NavUser;
